import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, dateFrom, dateTimeFrom, getURLParam, mapStateToProps, setTableParams, getLocalized } from "../../core/utils";
import { createSidebar, createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import ColorPreview from "../../components/ColorPreview";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import ColorsFlyout from "../../flyouts/superadmin/colors/ColorsFlyout";
import {
	deleteColors,
	listColors,
	readColor
} from "../../redux/actions/table/superadmin/colors";
import TableNA from "../../components/TableNA";
import { listLocalization } from "../../redux/actions/localization";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_colors"],
	auth: state.auth,
	application_language_id: state.auth.language_id,
}))
class Colors extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_color && setPlusActions([{
			title: "Add color",
			onClick: () => setTableParams('superadmin_colors', {
				add_color_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readColor(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		let columns = [
			{
				key: "hex",
				name: "Hex",
				width: 100,
				value: hex => (
					<Tooltip text={hex}>
						{hex ? <ColorPreview hex={hex} /> : <TableNA />}
					</Tooltip>
				)
			}, {
				key: "name",
				name: "Name",
				required: true,
				value: name => {
					const localized_name = getLocalized(name, application_language_id);
					return <Tooltip text={localized_name}>{localized_name}</Tooltip>
				}
			},
			{
				key: "raw_colors",
				name: "Filter colors",
				value: raw_colors => {
					const joined_raw_colors = _.join(raw_colors, ', ');

					return _.isEmpty(raw_colors) ? <TableNA /> : <Tooltip text={joined_raw_colors}>{joined_raw_colors}</Tooltip>;
				},
				sortable: false
			},
		];

		const singleActions = (color_id) => {
			return [
				<Tooltip text="Delete selected color" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected color?\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteColors([color_id]).then(() => {
												hideAlertbox();

												setNotification("The selected color has been deleted.");
												listColors();

												listLocalization();

												setTableParams('superadmin_colors', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (colors_ids) => [
			<Tooltip text="Delete selected colors" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these colors?\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteColors(colors_ids).then(() => {
											hideAlertbox();

											setNotification("The selected colors have been deleted.");
											listColors();

											listLocalization();

											setTableParams('superadmin_colors', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<ColorsFlyout
				data={this.state.preview}
				readAction={color_id => {
					return new Promise(resolve => {
						readColor(getURLParam('id') || color_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listColors}
				name="superadmin_colors"
				groupActions={superadmin.delete_color && groupActions}
				singleActions={superadmin.delete_color && singleActions}
				title={__("modules.submodules.title.colors")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default Colors;
